import * as React from "react";
import * as ReactDOM from 'react-dom/client';
import * as S from "@styled";
import { ToastContainer, toast, ToastOptions, Theme, Slide } from "react-toastify";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeProvider } from "styled-components";
import { GlobalStyle, ThemeType } from "shared/styles/theme";
import StylesheetProvider from "shared/providers/StylesheetProvider";

let hasContainer = false;

const toastBodyStyles = (theme: ThemeType): React.CSSProperties => ({
	fontFamily: "'Gilroy-Regular', 'regular-fallback'",
	fontSize: "16px",
	color: theme === ThemeType.light ? S.Colors.grey_1 : S.Colors.white,
	alignItems: "flex-start",
})

const toastStyles: React.CSSProperties = {
	boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.1)",
	borderRadius: "15px",
	border: `1px solid ${S.Colors.grey_2}`
}

export default function (content: string | JSX.Element, options: ToastOptions) {
	if (!hasContainer) {
		const container = document.getElementById('root-toastify');
		if (container) {
			const root = ReactDOM.createRoot(container);
			hasContainer = true;
			root.render(
				<ToastContainerWrapper render={theme => (
					<ToastContainer bodyStyle={toastBodyStyles(theme)} theme={theme} toastStyle={toastStyles} newestOnTop={true} />
				)} />
			);
		}
	}
	toast(content, { ...options, transition: Slide });
}

const ToastContainerWrapper: React.FC<ToastContainerWrapperProps> = (props) => {
	const [theme] = useUserTheme();
	return (
		<StylesheetProvider>
			<ThemeProvider theme={{ mode: theme }}>
				<GlobalStyle />
				{props.render(theme)}
			</ThemeProvider>
		</StylesheetProvider>
	)
}

type ToastContainerWrapperProps = {
	render(theme: ThemeType): React.ReactElement
}